import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  Button,
  Box,
  useMediaQuery,
} from "@mui/material";
import { WarningAmber as WarningIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";

export default function LicenseExpiryPopup({ open, setOpen, expireInDays }) {
  // const [open, setOpen] = useState(true);
  const theme = useTheme();
  console.log("expireInDays", expireInDays);
  const handleClose = () => setOpen(false);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: { xs: 2, sm: 3 },
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <WarningIcon sx={{ fontSize: 48, color: "#ff9800" }} />
        </Box>
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "1.2rem", sm: "1.4rem" },
            textAlign: "center",
            padding: 0,
            mb: 1,
          }}
        >
          License Expiry Warning
        </DialogTitle>
        {/* <Typography
          variant="body1"
          sx={{
            mt: 1,
            fontSize: { xs: "0.9rem", sm: "1rem" },
            textAlign: "center",
          }}
        >
          Your <strong>HLTHTek Platform </strong>license will expire in
          <strong> 30 days</strong>.
        </Typography> */}
        <Typography
          variant="body1"
          sx={{
            mt: 1,
            fontSize: { xs: "0.9rem", sm: "1rem" },
            textAlign: "center",
          }}
        >
          Your <strong>HLTHTek Platform </strong>license will expire in{" "}
          <strong>
            {expireInDays} {expireInDays === 1 ? "day" : "days"}
          </strong>
          .
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mt: 2,
            fontSize: { xs: "0.8rem", sm: "0.875rem" },
            textAlign: "center",
          }}
        >
          Please contact support:
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mt: 1,
            fontSize: { xs: "0.8rem", sm: "0.875rem" },
            textAlign: "center",
            wordBreak: "break-word",
          }}
        >
          📧 contactus@hlthtek.com
          <br />
          📞+91 9073940606
        </Typography>
        <DialogActions sx={{ justifyContent: "center", mt: 3, width: "100%" }}>
          {/* <Button
            onClick={handleClose}
            variant="contained"
            color="warning"
            fullWidth={fullScreen}
            sx={{
              borderRadius: 2,
              px: 4,
              fontSize: "1rem",
              maxWidth: { sm: 200 },
            }}
          >
            Dismiss
          </Button> */}

          <div
            className="col-sm-12 col-md-12 col-lg-12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              className="btn btn__secondary mt-10"
              type="button"
              onClick={handleClose}
              style={{ padding: "3px 6px", fontSize: "1rem" }}
            >
              Dismiss
            </button>
          </div>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
